import React from 'react';
import _isNaN from 'lodash/isNaN';
import dayjs from 'dayjs';
import { useStyletron } from 'baseui';

import { ChangesVersionHistory } from 'constant';
import { EMPTY_STRING } from 'commons-ui';

export const REQUIRED_KEYS = {
	IMAGE_URL: 'imageUrl',
	START: 'start',
	EXPIRES_AT: 'expiresAt',
	SORT_ORDER: 'sortOrder',
	LANGUAGE: 'language',
	LOCATION: 'location',
	TYPE: 'type',
	CTA_TYPE: 'cta.type',
	CTA_VALUE: 'cta.value',
	IS_CLOSED: 'isClosed'
};

export const requiredKeysList = Object.values(REQUIRED_KEYS);

export const useDataFormatter = () => {
	const [css] = useStyletron();

	const renderDate = (value: number) => (
		<div>{value && !_isNaN(value) ? dayjs(new Date(value)).format('MMM D, YYYY h:mm A').toString() : EMPTY_STRING}</div>
	);

	const renderImg = (imgSrc: string) => (
		<a href={imgSrc} target='_blank' rel='noreferrer'>
			<img src={imgSrc} alt='' className={css({ height: '90px' })} />
		</a>
	);

	const renderLanguage = (lang: string) => <div>{lang === 'hi' ? 'HINDI' : 'ENGLISH'}</div>;

	const renderBoolean = (value: boolean) => <div>{value ? 'TRUE' : 'FALSE'}</div>;

	const bannerHistoryFormatter = (data: ChangesVersionHistory) => {
		const { oldValue } = data;
		const { newValue } = data;
		let formattedOldValue;
		let formattedNewValue;
		switch (data.key) {
			case REQUIRED_KEYS.IMAGE_URL:
				formattedOldValue = renderImg(oldValue);
				formattedNewValue = renderImg(newValue);
				break;

			case REQUIRED_KEYS.EXPIRES_AT:
				formattedOldValue = renderDate(oldValue);
				formattedNewValue = renderDate(newValue);
				break;

			case REQUIRED_KEYS.LANGUAGE:
				formattedOldValue = renderLanguage(oldValue);
				formattedNewValue = renderLanguage(newValue);
				break;
			case REQUIRED_KEYS.IS_CLOSED:
				formattedOldValue = renderBoolean(oldValue);
				formattedNewValue = renderBoolean(newValue);
				break;

			default:
				formattedOldValue = oldValue;
				formattedNewValue = newValue;
				break;
		}

		return {
			...data,
			oldValue: formattedOldValue,
			newValue: formattedNewValue
		};
	};
	return {
		bannerHistoryFormatter
	};
};
